import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {takeLatest, select, take, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {selectEnv} from 'reducers/env';

import gql from 'graphql-tag';
import pick from 'lodash.pick';

const namespace = 'flows/account/bank';

export const Qoperation = 'ProfileBankAccounts';
export const query = gql`
query ${Qoperation} {
  userinfo {
    id
    sources {
      id
      institution {
        name
      }
      status
      bankAccountType
      type
      name
    }
  }
}
`;

export const Moperation = 'OnboardPlaid';
export const mutation = gql`
  mutation ${Moperation} ($plaid: PlaidResponse) {
    sources: onboardPlaid(plaid: $plaid) {
      id
      self
      name
    }
  }
`;

export const onboardProps = ({mutate}) => ({public_token, institution, account, link_session_id }) => {
  return mutate({
    variables: {
      plaid: {
        token: public_token,
        metadata: {
          public_token: public_token,
          institution: pick(institution, ['institution_id', 'name']),
          account: pick(account, ['name', 'type', 'subtype', 'mask']),
          account_id: account.id,
          link_session_id,
        }
      }
    },
  })
};

// Actions
const ONBOARDED_BANK_ACCOUNT = defineAction('ONBOARDED_BANK_ACCOUNT', namespace);

export const onboardedBankAccount = createAction(ONBOARDED_BANK_ACCOUNT.ACTION);

// Invest Agreement Saga
export function* onboardedBankAccountSaga({payload}) {
  const {account} = payload;

  const env = yield select(selectEnv);

  if (env.web) {
    // Show toast
    const message = `${account.name} added`;
    yield call([toast, toast.success], message, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
}

export function* sagas() {
  yield takeLatest(ONBOARDED_BANK_ACCOUNT.ACTION, onboardedBankAccountSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/account/bank/index.js